<template>
  <div class="wp">
    <div class="head">当前项目包含页面</div>
    <div class="line"></div>
    <ol class="list">
      <!-- 5811:project-index -->
      <router-link v-for="(item, index) of list" :to="item.path" :key="item.path">{{ item.meta ? item.meta.title :
        item.path
        }}</router-link>
    </ol>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  components: {
  },
  computed: {
  },
  data() {
    return {
      list: [
        {
          path: '/login',
          meta: {
            title: '登录'
          },

        },
        {
          path: '/signin',
          meta: {
            title: '注册'
          },

        },
        {
          path: '/password',
          meta: {
            title: '忘记密码'
          },

        },
        {
          path: '/password1',
          meta: {
            title: '忘记密码-马上登录'
          },

        },
        {
          path: '/home-supplier',
          meta: {
            title: '1-1供应商中心---心--企业主页-公司简介'
          },

        },
        {
          path: '/info-supplier',
          meta: {
            title: '1-1供应商中心---账号资料-我的信息'
          },

        },
        {
          path: '/info-password',
          meta: {
            title: '1-3供应商中心---修改密码'
          },

        },
        {
          path: '/info-qualifications',
          meta: {
            title: '1-4供应商中心---资质认证'
          },

        },
        {
          path: '/supplier-equity',
          meta: {
            title: '2-1供应商中心---我的会员-会员权益'
          },

        },
        {
          path: '/info-recharge',
          meta: {
            title: '2-2供应商中心---我的会员-在线充值'
          },

        },
        {
          path: '/info-record',
          meta: {
            title: '2-3供应商中心---我的会员-充值记录'
          },

        },
        {
          path: '/suppliercenter-onlinebook',
          meta: {
            title: '3-1供应商中心---在线选书-新建目录'
          },

        },
        {
          path: '/suppliercenter-bookmanagement',
          meta: {
            title: '3-2供应商中心---在线选书-目录管理'
          },

        },
        {
          path: '/suppliercenter-library',
          meta: {
            title: '4供应商中心---图书库'
          },

        },
        {
          path: '/suppliercenter-uploadlibrary',
          meta: {
            title: '4供应商中心---图书库--上传书目'
          },

        },
        {
          path: '/suppliercenter-submittedorder',
          meta: {
            title: '5供应商中心---已提交订单'
          },

        },
        {
          path: '/home-center',
          meta: {
            title: '01会员中心---我的主页-公司简介'
          },

        },
        {
          path: '/info-center',
          meta: {
            title: '1-1会员中心---我的信息'
          },

        },
        {
          path: '/center-password',
          meta: {
            title: '1-3会员中心---修改密码'
          },

        },
        {
          path: '/center-qualifications',
          meta: {
            title: '1-4会员中心---资质认证'
          },

        },
        {
          path: '/center-equity',
          meta: {
            title: '2-1会员中心---我的会员-会员权益'
          },

        },
        {
          path: '/center-recharge',
          meta: {
            title: '2-2会员中心---我的会员-在线充值'
          },

        },
        {
          path: '/center-record',
          meta: {
            title: '2-3会员中心---我的会员-充值记录'
          },

        },
        {
          path: '/membercenter-projectmanagement',
          meta: {
            title: '3会员中心---项目管理'
          },

        }, {
          path: '/membercenter-mycollection',
          meta: {
            title: '4会员中心---我的收藏'
          },

        }, {
          path: '/membercenter-myorder',
          meta: {
            title: '5会员中心---我的订单'
          },

        },
        {
          path: '/membercenter-submittedorder',
          meta: {
            title: '5会员中心---已提交订单'
          },

        }, {
          path: '/membercenter-myattention',
          meta: {
            title: '6-1会员中心---我的关注'
          },

        }, {
          path: '/membercenter-myfans',
          meta: {
            title: '6-2会员中心---我的粉丝'
          },

        }, {
          path: '/membercenter-messagecenter',
          meta: {
            title: '7会员中心---消息中心'
          },

        },
      ]
    }
  },
  created() {

  },
  mounted() {
  }
}
</script>
<style lang="scss" scoped>
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
}

body {
  background: #333;
  color: #6f828d;
  font: 14px/1.5 sans-serif;
  text-align: center;
}

a {
  color: #026eba;
  text-decoration: none;
  -webkit-transition: all .3s ease-out;
  -moz-transition: all .3s ease-out;
  -o-transition: all .3s ease-out;
  transition: all .3s ease-out;
}

a:visited {
  color: #999;
}

a:hover,
a:active {
  background: #2ea1f2;
  color: #fff;
}

.wp {
  margin: 0 auto;
  width: 480px;
  min-width: 320px;
  min-height: 100%;
  background: #fff;
}

.head {
  height: 80px;
  line-height: 80px;
  font-size: 20px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAMAAADXT/YiAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1QThBMDM1Qjk3NTgxMUU3QUY3RUE3RUVDMTBCOTg1MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1QThBMDM1Qzk3NTgxMUU3QUY3RUE3RUVDMTBCOTg1MCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjVBOEEwMzU5OTc1ODExRTdBRjdFQTdFRUMxMEI5ODUwIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjVBOEEwMzVBOTc1ODExRTdBRjdFQTdFRUMxMEI5ODUwIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+sOoKxgAAAAZQTFRF7u7u9vb2jxyS+AAAACNJREFUeNpiYGRkYAQBBgYYA8SEMOAiUBYDCg9JATa9AAEGAAv0AEPRWjmBAAAAAElFTkSuQmCC);
}

.line {
  margin: 1px 0;
  height: 2px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJoAAAACCAYAAACgysU5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpEMjA1MTBFMDk3NjExMUU3QUY3RUE3RUVDMTBCOTg1MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpEMjA1MTBFMTk3NjExMUU3QUY3RUE3RUVDMTBCOTg1MCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjVBOEEwMzYxOTc1ODExRTdBRjdFQTdFRUMxMEI5ODUwIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjVBOEEwMzYyOTc1ODExRTdBRjdFQTdFRUMxMEI5ODUwIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+oUbe1QAAAEdJREFUeNpi/P//P4P+os//GQYAXIzjZfwe5jIgdnOu2sP4/pjOgNgtaHWFMfRO74DYvVqlmPHsjXt0t5uJYRSMAjoAgAADADNIFoNRUtweAAAAAElFTkSuQmCC);
}

.list,
.list li {
  overflow: hidden;
  margin: 0;
  padding: 0;
  text-align: left;
  list-style: none;
}

.list a {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  padding: 12px 20px;
  border-bottom: 1px solid #f0f0f0;
}

@media only screen and (max-width: 480px) {
  .wp {
    width: 100%;
  }
}
</style>
